var _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "svg-box d-flex"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    className: "circular red-stroke",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "path",
    cx: 75,
    cy: 75,
    r: 50,
    fill: "none",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    className: "cross red-stroke",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-502.652,-204.518)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "first-line",
    d: "M634.087,300.805L673.361,261.53",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.28587e-16,-0.79961,0.79961,-1.28587e-16,-204.752,543.031)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "second-line",
    d: "M634.087,300.805L673.361,261.53"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.7ca3426565745b178b84f7f0ea309c70.svg";
export { ForwardRef as ReactComponent };